import React, { useEffect, useState, VFC } from 'react';
import styled from 'styled-components';
import Readonly from '../Readonly';
import FilterCallout from '../../../../../../../FilterCallout';

interface IProps {
  value: any[];
  onChange: (value: any[]) => void;
  connection?: {
    config: any;
    list: any[];
  };
  row: any;
  field: any;
  dataAttrQA: { [key: string]: string | number };
  readonly: boolean;
}


export const ConnectionComboBox: VFC<IProps> = (props) => {
  const { dataAttrQA, readonly, connection, value, onChange } = props;
  const [keys, setKeys] = useState<any[]>([]);
  const [isFilterShowing, setIsFilterShowing] = useState<boolean>(false);

  useEffect(() => {
    if (connection?.list) {
      const keys = connection.list.map((el: any) => ({
        id:   el.id,
        name: el.name,
      }));
      setKeys(keys);
    }
  }, [connection]);

  return (
    readonly
    ? <Readonly {...dataAttrQA}>{keys.join(', ')}</Readonly>
    : (
      <FilterCallout
        canLoadMore={false}
        onLoadMore={() => {}}
        showFilter={isFilterShowing}
        isLoading={false}
        filteredList={keys || []}
        onShowFilter={() => setIsFilterShowing(true)}
        onFilterClose={() => setIsFilterShowing(false)}
        field={''}
        acceptFilter={(_, keys) => {
          onChange(keys);
        }}
        isFiltered={false}
        useTextBlock
        emptyArrayOnAllChecked={false}
        defaultSelectedValues={value}
        displayAllInsteadOfElements={false}
        canAcceptEmpty
        hideSearch
        styles={{
          textInput: {
            border: 'none',
          },
        }}
      />
    )
  )
}

export default ConnectionComboBox;
